export const API_URL = "https://valerotexasopen.com/notify/api";
export const RECAPTCHA_KEY = "6LfkuhkUAAAAAMtYySi117tvZtrs0fzC2RzCVrEE";

export function createMarkup(html) {
	return { __html: html };
}

export function isFieldError(array, val) {
	return array.includes(val);
}

export function scroll() {
	return window.jQuery("html, body").animate(
		{
			scrollTop:
				window.jQuery("#notify-notify-root").offset().top -
				window.jQuery("#header").height(),
		},
		200
	);
}

const isBrowser = () => typeof window !== "undefined";

export const getValFromLS = (key, useSessionStorage = false) => {
	if (useSessionStorage) {
		return isBrowser() && window.sessionStorage.getItem(key)
			? window.sessionStorage.getItem(key)
			: undefined;
	} else {
		return isBrowser() && window.localStorage.getItem(key)
			? window.localStorage.getItem(key)
			: undefined;
	}
};

export const setValToLS = (key, val, useSessionStorage = false) => {
	if (isBrowser() && val) {
		useSessionStorage
			? window.sessionStorage.setItem(key, val)
			: window.localStorage.setItem(key, val);
	} else {
		useSessionStorage
			? window.sessionStorage.removeItem(key)
			: window.localStorage.removeItem(key);
	}
	return true;
};
